import React, {} from 'react';
import Datas from '../../../data/free-course/free-course2.json';
import { Container, Row, Col } from 'react-bootstrap';
import { Styles } from "../../styles/freeCourse2.js";
import { useTranslation } from 'react-i18next';

function FreeCourse2() {
    const { t } = useTranslation();

    return (
        <Styles>
            {/* Free Course */}
            <section className="free-course-area">
                <Container>
                    <Row>
                        <Col md="6">
                            <img src={process.env.PUBLIC_URL + `/assets/images/${Datas.howWeWorkImage}`} alt="how_we_work" className="how_we_work_image_new" />
                        </Col>
                        <Col md="6">
                            <div className="course-text">
                                <h4>{t('home.values.title')}</h4>
                                <p><strong>{t('home.values.items.0.title')}:</strong> {t('home.values.items.0.text')}</p>
                                <p><strong>{t('home.values.items.1.title')}:</strong> {t('home.values.items.1.text')}</p>
                                <p><strong>{t('home.values.items.2.title')}:</strong> {t('home.values.items.2.text')}</p>
                                <p><strong>{t('home.values.items.3.title')}:</strong> {t('home.values.items.3.text')}</p>
                                <p><strong>{t('home.values.items.4.title')}:</strong> {t('home.values.items.4.text')}</p>
                                <p><strong>{t('home.values.items.5.title')}:</strong> {t('home.values.items.5.text')}</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </Styles>
    );
}

export default FreeCourse2